var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3Dcube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.8252 14.2001L33.1502 5.75007C31.5002 4.85007 29.5002 4.85007 27.8502 5.75007L12.1752 14.2001C11.0252 14.8251 10.3252 16.0251 10.3252 17.4001C10.3252 18.7501 11.0252 19.9751 12.1752 20.6001L27.8502 29.0501C28.6752 29.5001 29.6002 29.7251 30.5002 29.7251C31.4002 29.7251 32.3252 29.5001 33.1502 29.0501L48.8252 20.6001C49.9752 19.9751 50.6752 18.7751 50.6752 17.4001C50.6752 16.0251 49.9752 14.8251 48.8252 14.2001Z",
    fill: "#004192"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M25.275 31.975L10.675 24.675C9.55 24.125 8.25 24.175 7.2 24.825C6.125 25.5 5.5 26.625 5.5 27.875V41.65C5.5 44.025 6.825 46.175 8.95 47.25L23.525 54.55C24.025 54.8 24.575 54.925 25.125 54.925C25.775 54.925 26.425 54.75 27 54.4C28.075 53.75 28.7 52.6 28.7 51.35V37.575C28.725 35.175 27.4 33.025 25.275 31.975Z",
    fill: "#004192"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M53.7998 24.8251C52.7248 24.1751 51.4248 24.1001 50.3248 24.6751L35.7498 31.9751C33.6248 33.0501 32.2998 35.1751 32.2998 37.5751V51.3501C32.2998 52.6001 32.9248 53.7501 33.9998 54.4001C34.5748 54.7501 35.2248 54.9251 35.8748 54.9251C36.4248 54.9251 36.9748 54.8001 37.4748 54.5501L52.0498 47.2501C54.1748 46.1751 55.4998 44.0501 55.4998 41.6501V27.8751C55.4998 26.6251 54.8748 25.5001 53.7998 24.8251Z",
    fill: "#004192"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Dcube);
export default __webpack_public_path__ + "static/media/3dcube.44040e8bc364c66a70f6adf6ab792021.svg";
export { ForwardRef as ReactComponent };